import React from 'react';
import "./NoMatch.css"

const NoMatch = () => {
    return (
        <div className="container notmatch">
            <h1>Sorry, page not found</h1>
            <h3>404 Error!!!</h3>
        </div>
    );
};

export default NoMatch;